// intro transition
function transitionIntro() {
  // creating intro divs
  const introOverDiv = document.createElement("div");
  introOverDiv.classList.add("transition-overlay");
  const introUnderDiv = document.createElement("div");
  introUnderDiv.classList.add("transition-underlay");
  const introLogoDiv = document.createElement("div");
  introLogoDiv.classList.add("intro-logo");
  // appending logo svg to logo div
  introLogoDiv.innerHTML += '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 116.3 140.7" style="enable-background:new 0 0 116.3 140.7;" xml:space="preserve"><path style="fill:#FFFFFF;stroke:#FFFFFF;stroke-miterlimit:10;" d="M69.5,44l-0.1-0.2L46.5,83.5c-2.3-3.9-3.6-8.5-3.6-13.3c0-14.6,11.9-26.5,26.5-26.5c9.8,0,18.4,5.4,23,13.3l7.3-12.6c-7.3-8.6-18.2-14-30.3-14c-21.9,0-39.8,17.8-39.8,39.8c0,9.9,3.6,19,9.6,25.9l-7.4,12.8c-10.1-9.8-16.5-23.5-16.5-38.7c0-29.8,24.2-54,54-54c14.6,0,27.9,5.9,37.7,15.4l6.8-11.8C102,9.3,86.4,2.9,69.4,2.9C32.3,2.9,2.1,33.1,2.1,70.2s30.2,67.3,67.2,67.3c17,0,32.5-6.3,44.4-16.8L69.5,44z M82.6,93.1c-3.9,2.2-8.4,3.5-13.2,3.5c-4.8,0-9.3-1.3-13.2-3.5l13.2-22.9L82.6,93.1z M42.5,116.9l7.1-12.3c5.8,3.4,12.6,5.3,19.8,5.3c7.2,0,14-1.9,19.8-5.3l7.1,12.3c-7.9,4.6-17.1,7.2-26.9,7.2C59.6,124.1,50.4,121.5,42.5,116.9z"/></svg>';
  // adding logo to underlay div
  introUnderDiv.appendChild(introLogoDiv);
  //adding created divs to before the header
  const siteHeader = document.getElementById("site-header");
  document.body.insertBefore(introUnderDiv, siteHeader);
  document.body.insertBefore(introOverDiv, introUnderDiv);

  // transition animation
  const introLogoSvgPath = document.querySelector(".transition-underlay .intro-logo svg path");
  setTimeout(function() {
    introOverDiv.classList.add('loaded');
  }, 100);
  setTimeout(function() {
    introLogoSvgPath.style.opacity = '1';
  }, 350);
  setTimeout(function() {
    introUnderDiv.classList.add('loaded');
  }, 1500);
  setTimeout(function() {
    introOverDiv.remove();
    introUnderDiv.remove();
  }, 2000);
}

document.addEventListener("DOMContentLoaded", (event) => {
  // AOS.init();
  const elementBody = document.querySelector("body");

  // only show intro animation when it's the homepage
  if ( elementBody.classList.contains('home') ) {
    transitionIntro();
  }

  //init sliders
  const postSwiper = new Swiper('.post-slider', {
    loop: false,
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 24,
    pagination: {
      enabled: false,
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      enabled: true,
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      480: {
        slidesPerView: 1.25,
        slidesPerGroup: 1,
        pagination: {
          enabled: true,
        },
        navigation: {
          enabled: false,
        },
      },
      768: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        pagination: {
          enabled: true,
        },
        navigation: {
          enabled: false,
        },
      },
      900: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        pagination: {
          enabled: true,
        },
        navigation: {
          enabled: false,
        },
      }
    },
  });
  
});






// Legacy jQuery Code
jQuery(document).ready(function( $ ) {

    // ANNUAL REVIEW 2021
    // if ( !$('body').hasClass('page-template-template-annualreview-2021') || !$('body').hasClass('page-template-template-annualreview-2022') ) {
    //   $('main#site-content h2, main#site-content h3, main#site-content h4, main#site-content p, .entry-content li').attr('data-aos', 'fade-in');
    // }

    // BACK TO TOP
    $(window).scroll(function () {
        var scrollY = $(window).scrollTop();
        if ( scrollY > 135 ) {
            $('.back-to-top').css({'opacity':'1'});
            $('header#site-header').addClass('mini');
        } else {
            $('.back-to-top').css({'opacity':'0'});
            $('header#site-header').removeClass('mini');
        }
    });

    // CHAT POPUP
    $('.chat-popup-trigger').click(function() {
      if ( $('.chat-popup-wrapper').hasClass('opened') ) {
        $('.chat-popup-wrapper').removeClass('opened');
        $('.chat-popup-trigger i').removeClass('fa-times-circle');
        $('.chat-popup-trigger i').addClass('fa-comment-alt');
      } else {
        $('.chat-popup-wrapper').addClass('opened');
        $('.chat-popup-trigger i').removeClass('fa-comment-alt');
        $('.chat-popup-trigger i').addClass('fa-times-circle');
      }
    });

    // ACCORDION
    $('.mission-accordion').click(function() {
      if ( $(this).hasClass('opened') ) {
        $(this).removeClass('opened');
      } else {
        $(this).addClass('opened');
      }
    });
    
    // LIGHTBOX
    $('.wp-block-button.lightbox a').fancybox({});

    // BUCKETS
    $('.section.buckets').parent().parent().addClass("wp-block-group-wide");
    $('.bucket-sm').parent().addClass("bucket-sm-container").parent().addClass("wp-block-group-wide");
    $('.bucket-sm-2').parent().parent().addClass("bucket-sm-container");

    // SLIDERS

    $('.bucket-slider').slick({
      infinite: true,
      dots: false,
      arrows: true,
      slidesToShow: 2,
      slidesToScroll: 2,
      variableWidth: true,
      variableHeight: false,
      responsive: [
        {
          breakpoint: 900,
          settings: {
            arrows: true,
            centerMode: true,
            centerPadding: '40px',
            slidesToShow: 1
          }
        }
      ]
    });

    $('.YIR2019-logo-slider').slick({
      infinite: true,
      dots: false,
      arrows: false,
      slidesToShow: 6,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 6000,
      responsive: [
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
          }
        }
      ]
    });

    $('.gallery-slider').slick({
      infinite: true,
      dots: true,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 6000,
    });

    $('.stats-slider').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      autoplay: true,
      autoplaySpeed: 6000,
    });

});